export default __webpack_public_path__ + "static/yoga-pose-correction-ai-computer-vision-b77aa0dd085c64bf5ad261f7b80e54cc.jpeg";